import { render, staticRenderFns } from "./Motoristas.vue?vue&type=template&id=60631cb4&scoped=true&"
import script from "./Motoristas.vue?vue&type=script&lang=js&"
export * from "./Motoristas.vue?vue&type=script&lang=js&"
import style0 from "./Motoristas.vue?vue&type=style&index=0&id=60631cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60631cb4",
  null
  
)

export default component.exports